import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { Components } from '@grandvisionhq/stores-v2';
import { formatDistance } from '@grandvisionhq/utils';
import { fromStoreToStoreResult } from '../../pages/BookAppointment/adapters/from-store-to-store-result.js';

const { StoreFinderClickableItem , StoreFinderItem  } = Components;
const AlternativeStoreItem = ({ item , getTimeslotLabel , onClickStore  })=>{
    const { distanceUnit  } = useIntl();
    const formattedDistance = item.store.distance && formatDistance(item.store.distance, distanceUnit, {
        separator: ' '
    });
    return /*#__PURE__*/ React.createElement(StoreFinderClickableItem, {
        variant: "list-item",
        key: item.store.globalStoreId,
        className: "alternative-store-item",
        onClick: ()=>{
            return onClickStore === null || onClickStore === void 0 ? void 0 : onClickStore(item.store, item.nextAvailableBookingDate);
        }
    }, /*#__PURE__*/ React.createElement(StoreFinderItem, {
        showOpeningHours: false,
        showEmailAddress: false,
        showPhone: false,
        store: fromStoreToStoreResult(item.store),
        distance: formattedDistance,
        addressSize: "MINIMAL",
        availability: /*#__PURE__*/ React.createElement(Text, {
            className: "alternative-store-item__timeslots-label",
            variant: "caption-head",
            component: "p"
        }, getTimeslotLabel(item))
    }));
};

export { AlternativeStoreItem as default };
//# sourceMappingURL=AlternativeStoreItem.js.map
